// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"0810d0b6","361":"245bc08c","399":"fcc4ffc5","787":"2aa19c63"}[chunkId] + ".chunk.js";
};